// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"807a24a8","248":"5efc7f3b","319":"58989380","364":"b26d4f2d","471":"8f4dd352","499":"42d6ce22","566":"57dcdd04","583":"c440f5bf","756":"f0b23fbe","895":"d76c332f","907":"03d2868a","983":"f7f55dab"}[chunkId] + ".chunk.js";
};